import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className="footer-container">
      <h5>&#169;  2023</h5>
    </div>
  )
}

export default Footer